'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var colors = require('../../../constants/colors.js');
var sizes = require('../../../constants/sizes.js');
var variants = require('../../../constants/variants.js');
var Icon_module = require('../styles/Icon.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Icon container.
 *
 * @component
 * @example
 * ```jsx
 * <Icon size={28} icon={<ArrowUpIcon />} />
 * ```
 */
const Icon = React__namespace.forwardRef((props, ref) => {
    const { icon, size, strong, color, background, variant = variants.VARIANTS.SECONDARY, shape, style = {}, children, className, ...restProps } = props;
    const cx = reactUtils.useStyles(Icon_module.default);
    const classNames = cx(className, 'container', {
        strong,
        [`size-${size}`]: size,
        [`color-${color}`]: color,
        [`background-${variant}-${background}`]: background,
        [`shape-${shape}`]: shape,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'as-container': shape,
    });
    return (React__namespace.createElement("span", { "data-qa": "Icon", ref: ref, className: classNames, style: style, ...restProps }, children || icon));
});
Icon.defaultProps = {
    size: sizes.CONTENT_SIZES.S20,
    variant: variants.VARIANTS.SECONDARY,
    background: colors.COLORS.DARK,
};
Icon.displayName = 'Icon';

exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map
